// src/utils/cookieUtils.js

/**
 * Sets a cookie with a given name, value, and expiration in days.
 * This is used to remember the user's device and quality settings.
 * @param {string} name The name of the cookie.
 * @param {string} value The value to store.
 * @param {number} days The number of days until the cookie expires.
 */
export function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (encodeURIComponent(value) || "") + expires + "; path=/; SameSite=Lax";
}

/**
 * Retrieves the value of a cookie by its name.
 * @param {string} name The name of the cookie to retrieve.
 * @returns {string|null} The cookie's value, or null if not found.
 */
export function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) {
            return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
    }
    return null;
}
